import { apiInstance } from "@/utils/ApiUtil.js";
const API_URL = "/task";

const createTask = async (taskData) => {
  try {
    const response = await apiInstance.post(`${API_URL}/create`, taskData);
    return response.data;
  } catch (error) {
    console.error("Create Task Error:", error);
    return false;
  }
};

const getUserTasks = async () => {
  try {
    const response = await apiInstance.get(`${API_URL}/all`);
    if(!response.data.success) return false
    return response.data.tasks;
  } catch (error) {
    console.error("Get User Tasks Error:", error);
    return false;
  }
};

const deleteTask = async ({ taskId }) => {
  try {
    const response = await apiInstance.delete(`${API_URL}/delete`, {
      data: { taskId },
    });
    return response.data;
  } catch (error) {
    console.error("Delete Task Error:", error);
    return false;
  }
};

const completeTask = async ({taskId }) => {
  try {
    const response = await apiInstance.post(`${API_URL}/complete`, { taskId });
    return response.data;
  } catch (error) {
    console.error("Complete Task Error:", error);
    return false;
  }
};

const TaskService = {
  createTask,
  getUserTasks,
  deleteTask,
  completeTask,
};

export default TaskService;
